const SHEET_HEADERS = {
  anio: "AÑO",
  maestria: "MAESTRIAS",
  cohorte: "COHORTE",
  fecha_inicio: "FECHA INICIO MAESTRIA",
  fecha_fin: "FECHA FIN MAESTRIA",
  cedula: "CEDULA",
  estudiante: "ESTUDIANTES",
  tema: "TEMA DE TITULACI\u00d3N",
  director: "DIRECTOR / TUTOR",
  tutor: "TUTOR ",
  cotutor: "COTUTOR",
  evaluador: "EVALUADOR O REVISOR",
  evaluador1: "EVALUADOR 1",
  evaluador2: "EVALUADOR 2",
  fecha_graduacion: "FECHA DE GRADUACI\u00d3N",
  examen: "EXAMEN COMPLEXIVO",
  resol_ca: "RESOL. APROBACI\u00d3N C.A.",
  fecha_resol_ca: "FECHA RESOL. C.A.",
  resol_cua: "RESOL. APROBACI\u00d3N CUA",
  fecha_resol_cua: "FECHA RESOL. CUA",
  fecha_mat2: "FECHA MAT. TITULACI\u00d3N 2",
  prorroga1: "PRIMERA PR\u00d3RROGA",
  prorroga2: "SEGUNDA PR\u00d3RROGA",
  mat_estado: "MAT. ACT.\nREACT. MAT.\nPRORROGA",
  estado_contratacion_director: "ESTADO DE CONTRATACION DEL DIRECTOR",
  estado: "ESTADO",
  fecha_tentativa: "FECHA TENTATIVA",
  periodo_inicio: "PERIODO ACAD\u00c9MICO INICIO: MATERIA DE TITULACION",
  pendiente_actualizacion: "POR REALIZAR MATERIA DE ACTUALIZACION",
  materia_reprobada: "MATERIA EN QUE REPROBO",
  deudas: "DEUDAS",
  estado_contratacion_evaluador: "ESTADO DE CONTRATACION DEL EVALUADOR"
};

const FIELD_ALIASES = {
  ano: "anio",
  anio: "anio",
  a_o: "anio",
  ano_de_registro: "anio",
  anio_de_registro: "anio",
  maestria: "maestria",
  maestrias: "maestria",
  cohorte: "cohorte",
  fecha_inicio: "fecha_inicio",
  fecha_inicio_maestria: "fecha_inicio",
  fecha_fin: "fecha_fin",
  fecha_fin_maestria: "fecha_fin",
  cedula: "cedula",
  estudiante: "estudiante",
  estudiantes: "estudiante",
  tema: "tema",
  tema_de_titulacion: "tema",
  director: "director",
  director_tutor: "director",
  tutor: "tutor",
  cotutor: "cotutor",
  evaluador: "evaluador",
  evaluador_o_revisor: "evaluador",
  evaluador1: "evaluador1",
  evaluador_1: "evaluador1",
  evaluador2: "evaluador2",
  evaluador_2: "evaluador2",
  fecha_graduacion: "fecha_graduacion",
  fecha_de_graduacion: "fecha_graduacion",
  examen: "examen",
  examen_complexivo: "examen",
  resol_ca: "resol_ca",
  resol_aprobacion_c_a: "resol_ca",
  fecha_resol_ca: "fecha_resol_ca",
  fecha_resol_c_a: "fecha_resol_ca",
  resol_cua: "resol_cua",
  resol_aprobacion_cua: "resol_cua",
  fecha_resol_cua: "fecha_resol_cua",
  fecha_mat2: "fecha_mat2",
  fecha_mat_titulacion_2: "fecha_mat2",
  prorroga1: "prorroga1",
  primera_prorroga: "prorroga1",
  prorroga2: "prorroga2",
  segunda_prorroga: "prorroga2",
  mat_estado: "mat_estado",
  mat_act_react_mat_prorroga: "mat_estado",
  estado_contratacion_director: "estado_contratacion_director",
  estado_de_contratacion_del_director: "estado_contratacion_director",
  estado: "estado",
  fecha_tentativa: "fecha_tentativa",
  periodo_inicio: "periodo_inicio",
  periodo_academico_inicio_materia_de_titulacion: "periodo_inicio",
  pendiente_actualizacion: "pendiente_actualizacion",
  por_realizar_materia_de_actualizacion: "pendiente_actualizacion",
  materia_reprobada: "materia_reprobada",
  materia_en_que_reprobo: "materia_reprobada",
  deudas: "deudas",
  estado_contratacion_evaluador: "estado_contratacion_evaluador",
  estado_de_contratacion_del_evaluador: "estado_contratacion_evaluador"
};

export const CAMPOS_REGISTRO = Object.keys(SHEET_HEADERS);

const CAMPOS_FECHA = new Set([
  "fecha_inicio",
  "fecha_fin",
  "fecha_graduacion",
  "fecha_resol_ca",
  "fecha_resol_cua",
  "fecha_mat2",
  "fecha_tentativa"
]);

const pad2 = (valor) => String(valor).padStart(2, "0");

const fechaValida = (anio, mes, dia) => {
  const fecha = new Date(Date.UTC(anio, mes - 1, dia));

  return (
    fecha.getUTCFullYear() === anio &&
    fecha.getUTCMonth() === mes - 1 &&
    fecha.getUTCDate() === dia
  );
};

const formatearFechaIso = (anio, mes, dia) =>
  fechaValida(anio, mes, dia) ? `${anio}-${pad2(mes)}-${pad2(dia)}` : "";

export const normalizarFechaParaInput = (valor) => {
  if (valor === null || valor === undefined || valor === "") {
    return "";
  }

  if (valor instanceof Date && !Number.isNaN(valor.getTime())) {
    return formatearFechaIso(valor.getFullYear(), valor.getMonth() + 1, valor.getDate());
  }

  if (typeof valor === "number" && Number.isFinite(valor)) {
    const baseExcel = Date.UTC(1899, 11, 30);
    const fecha = new Date(baseExcel + valor * 24 * 60 * 60 * 1000);
    return formatearFechaIso(fecha.getUTCFullYear(), fecha.getUTCMonth() + 1, fecha.getUTCDate());
  }

  const texto = String(valor).trim();

  if (!texto) {
    return "";
  }

  const iso = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) {
    return formatearFechaIso(Number(iso[1]), Number(iso[2]), Number(iso[3]));
  }

  const fechaLatam = texto.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{2,4})$/);
  if (fechaLatam) {
    const dia = Number(fechaLatam[1]);
    const mes = Number(fechaLatam[2]);
    const anioTexto = fechaLatam[3];
    const anio = Number(anioTexto.length === 2 ? `20${anioTexto}` : anioTexto);
    return formatearFechaIso(anio, mes, dia);
  }

  const timestamp = Date.parse(texto);
  if (!Number.isNaN(timestamp)) {
    const fecha = new Date(timestamp);
    return formatearFechaIso(fecha.getFullYear(), fecha.getMonth() + 1, fecha.getDate());
  }

  return texto;
};

export const obtenerAnioDeFecha = (valor) => {
  const fecha = normalizarFechaParaInput(valor);
  const coincidencia = String(fecha ?? "").match(/^(\d{4})-\d{2}-\d{2}$/);

  return coincidencia ? coincidencia[1] : "";
};

export const normalizarAnioRegistro = (valor) => {
  const texto = String(valor ?? "").trim();
  const coincidencia = texto.match(/\d{4}/);

  return coincidencia ? coincidencia[0] : texto;
};

export const normalizeKey = (value) =>
  String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\r?\n/g, " ")
    .replace(/[^a-zA-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .toLowerCase();

export const normalizarRegistroDesdeSheet = (registro = {}) => {
  const normalizado = {};

  Object.entries(registro).forEach(([clave, valor]) => {
    if (clave === "_rowNumber") {
      normalizado._rowNumber = valor;
      return;
    }

    const campo = FIELD_ALIASES[normalizeKey(clave)];

    if (!campo) {
      return;
    }

    if (campo === "anio") {
      normalizado[campo] = normalizarAnioRegistro(valor);
      return;
    }

    normalizado[campo] = CAMPOS_FECHA.has(campo) ? normalizarFechaParaInput(valor) : valor;
  });

  return normalizado;
};

export const serializarRegistroParaSheet = (registro = {}) => {
  const payload = {};

  CAMPOS_REGISTRO.forEach((campo) => {
    payload[SHEET_HEADERS[campo]] = registro?.[campo] ?? "";
  });

  if (registro?._rowNumber) {
    payload._rowNumber = registro._rowNumber;
  }

  if (registro?.action) {
    payload.action = registro.action;
  }

  return payload;
};
